module.exports = __webpack_public_path__ + "static/media/estilosos_feminino_acima_de_400.955e732b.jpg";